var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    transform: "translate(19 180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,17.116,2,22.3,7.184,21A10.145,10.145,0,1,0,3.3,17.116Zm9.576-5.468a2.593,2.593,0,0,0-.886.517,1.718,1.718,0,0,0-.489,1.2v.957h1.3v-.852a.767.767,0,0,1,.512-.695,3.321,3.321,0,1,0-4.427-3.77l1.3.332a1.97,1.97,0,0,1,3.915.332,1.923,1.923,0,0,1-.958,1.855c-.091.042-.184.081-.277.12Zm0,4.127v1.45h-1.45v-1.45Z",
    transform: "translate(28.35 189.35)",
    fill: "#787c7c",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9d627f7f18e5ed72a45b2bae6b98a429.svg";
export { ForwardRef as ReactComponent };